import React from 'react';
import moment from 'moment';

import {
    Card,
    Table,
    message,
    Tag,
    Modal,
    Button
} from 'antd'

import {
    _getProductPriceFlags
} from '../../services'

import {
    SUPPLIER_URL
} from '../../index'

const lowerLimit = 3.33
const upperLimit = 6.67

class PriceFlag extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            products: [],
            subCatStats: {},

            helpModalVisible: false
        }
    }

    render() {
        return (
            <Card
                title={<Button
                    type="primary"
                    onClick={() => this.setState({ helpModalVisible: true })}
                >User Guide</Button>}>
                {this.renderPriceFlagTable()}
                {this.state.helpModalVisible &&
                    <Modal
                        title="User Guide"
                        visible={this.state.helpModalVisible}
                        onCancel={() => this.setState({ helpModalVisible: false })}
                        onOk={() => this.setState({ helpModalVisible: false })}
                    >
                        {this.renderHelpContent()}
                    </Modal>
                }
            </Card>
        )

    }

    componentDidMount() {

        message.loading('Data is loading...',0)

        _getProductPriceFlags()
        .then(data => {
            message.destroy()
            message.success('Data is loaded!', 5)
            const products = data.data.products.sort((a,b) => {
                if (moment(b.dateUpdated).isAfter(moment(a.dateUpdated))) {
                    return 1
                } else {
                    return -1
                }
            })

            this.setState({
                products: products,
                subCatStats: data.data.subCatStats
            })
        })
    }

    renderPriceFlagTable = () => {

        const { products, subCatStats } = this.state

        const columns = [{
            title: 'Last Updated',
            dataIndex: 'dateUpdated',
            render: (dateUpdated) => moment(dateUpdated).format('DD-MM-YYYY HH:mm'),
            width: 150
        },{
            title: 'Title',
            dataIndex: 'title',
            width: 600,
            render: (title, record) => <a href={`${SUPPLIER_URL}/products/${record._id}`} target='_blank'>{title}</a>
        },{
            title: 'Price',
            dataIndex: 'price.original',
        },{
            title: 'Score',
            dataIndex: 'score',
            render: (score) => score.toFixed(2)
        },{
            title: 'Flag',
            render: (price, record) => {
                if (record.score>=upperLimit) {
                    return <Tag color="red">Too High</Tag>
                } 
                if (record.score<=lowerLimit) {
                    return <Tag color="blue">Too Low</Tag>
                } 
            }
        },{
            title: 'Sub-Cat',
            dataIndex: 'categories.sub'
        },{
            title: 'Sub-Cat Average',
            render: (categories,record) => subCatStats[record.categories.subKebabCase].avgPrice.toFixed(2)
        },{
            title: 'Sub-Cat StdDev',
            render: (categories,record) => subCatStats[record.categories.subKebabCase].stdDev.toFixed(2)
        }
        ]

        return (
            <Table
                dataSource={products}
                columns={columns}
                pagination={false}
                size="small"
            />
        )
    }

    renderHelpContent = () => {

        return(
        <div>
            <h3>What is this page for?</h3>
            <p>Shows the products that have been updated in the past 7 days. As well as their current price versus the average price of all items in the sub-category that the product is in</p>
            <br/>
            <h3>How to read it?</h3>
            <p>Score is a range from 0 to 10</p>
            <p>A score more than 6.67 is 'Too High' in comparison to its peers in the sub-category</p>
            <p>A score less than 3.33 is 'Too Low' in comparison to its peers in the sub-category</p>
            <h3>How to use it?</h3>
            <p>Scan through the products that are flagged, and if any of the prices appears out of the ordinary to you. Please double check the price with the supplier and upate it. Clicking on the 'title' of the product will bring you to the product editor page.</p>

        </div>
        )
    }
}

export default PriceFlag


// WEBPACK FOOTER //
// ./src/components/product/price-flags.js